import { SkinnableComponent } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import { useCustomMembershipSignupLogic } from './CustomMembershipSignupLogic';
import BasicCustomMembershipSignupSkin from './skins/BasicCustomMembershipSignupSkin';

/**
 * 커스텀 멤버십 가입 스킨 가능 컴포넌트 정의
 */
export const CustomMembershipSignupSkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.CUSTOM_MEMBERSHIP_SIGNUP,
  name: '커스텀 멤버십 가입',
  category: 'auth',
  options: [],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicCustomMembershipSignupSkin as any
  },
  useLogic: useCustomMembershipSignupLogic as any,
  defaultProps: {
    title: '커스텀 멤버십 가입',
    productId: 0,
    buttonText: '가입 신청',
    completedText: '가입 완료',
    description: '원하는 옵션을 선택하여 멤버십에 가입하세요.',
    askAmount: true,
    askQuantity: true,
    askAdditionalProducts: false,
    minAmount: 0,
    maxAmount: 100000000,
    minQuantity: 1,
    maxQuantity: 100,
    buttonColor: '#007bff',
    titleColor: '#333333',
    descriptionColor: '#666666',
    componentProps: {
      skin: 'basic',
      title: '커스텀 멤버십 가입',
      productId: 0,
      buttonText: '가입 신청',
      completedText: '가입 완료',
      description: '원하는 옵션을 선택하여 멤버십에 가입하세요.',
      askAmount: true,
      askQuantity: true,
      askAdditionalProducts: false,
      minAmount: 0,
      maxAmount: 100000000,
      minQuantity: 1,
      maxQuantity: 100
    }
  }
};